import React, { useEffect, useMemo, useState } from 'react'
import appUserService from '../../../services/appUserService'
import { normalizePlate } from '../../../helper/validatorPlateNumber'
import { formatDate } from '../../AutoTrafficFineNotificationLookup/utils/formatDate'
import trafficFineViolationItem from '../../../assets/images/traffic_fine_violation_item.png'
import trafficFineViolationStatus from '../../../assets/images/traffic_fine_violation_status.png'

function fixTimeText(s = '') {
  return String(s)
    .replace(/:\s+/g, ':')
    .replace(/^(\d{1,2}:\d{2})\s+/, '$1, ')
}

function FieldRow({ label, value }) {
  return (
    <div className="traffic-fine-violation-field">
      <div className="traffic-fine-violation-field-label">{label}</div>
      <div className="traffic-fine-violation-field-value">{value || '—'}</div>
    </div>
  )
}

function ViolationItem({ violation, index, carTypeLabel, defaultOpen = true }) {
  const [open, setOpen] = useState(defaultOpen)
  const statusLabel = violation?.crimeRecordStatus || ''

  return (
    <div className="traffic-fine-violation-item">
      <button type="button" className="traffic-fine-violation-item-header" onClick={() => setOpen((v) => !v)}>
        <div className="traffic-fine-violation-header-icon-wrap">
          <img src={trafficFineViolationItem} alt="icon lỗi" />
        </div>

        <div className="traffic-fine-violation-header-main">
          <div className="traffic-fine-violation-header-title">Lỗi {index + 1}</div>
          <div className="traffic-fine-violation-header-sub">
            Vi phạm lúc {violation?.crimeRecordTime ? fixTimeText(formatDate(violation.crimeRecordTime)) : '—'}
          </div>
        </div>

        <span className={`traffic-fine-violation-arrow ${open ? 'is-open' : ''}`}>
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M6 14L12 8L18 14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>

      <div className={`traffic-fine-violation-collapse ${open ? 'is-open' : ''}`}>
        <div className="traffic-fine-violation-collapse-inner">
          <div className="traffic-fine-violation-status-row">
            <div className="traffic-fine-violation-field-label">Trạng thái</div>
            {statusLabel ? (
              <div className="traffic-fine-violation-status-chip">
                <img src={trafficFineViolationStatus} alt="" />
                <span>{statusLabel}</span>
              </div>
            ) : (
              <div className="traffic-fine-violation-field-value">—</div>
            )}
          </div>

          <FieldRow label="Loại phương tiện" value={carTypeLabel} />
          <FieldRow label="Màu biển số" value={violation?.customerRecordPlateColorDesc} />
          <FieldRow label="Địa điểm vi phạm" value={violation?.crimeRecordLocation} />
          <FieldRow label="Hành vi vi phạm" value={violation?.crimeRecordContent} />
          <FieldRow label="Đơn vị phát hiện vi phạm" value={violation?.crimeRecordPIC} />
          <FieldRow label="Nơi giải quyết vụ việc" value={violation?.crimeRecordAgency} />
        </div>
      </div>
    </div>
  )
}

export default function ViolationInlineList({ licensePlate, carTypeLabel, autoOpen = true, vehicleType, onCountChange }) {
  const plate = useMemo(() => normalizePlate(licensePlate || ''), [licensePlate])

  const [violations, setViolations] = useState([])
  const [loading, setLoading] = useState(false)
  const [err, setErr] = useState('')

  useEffect(() => {
    let mounted = true

    async function fetchViolations() {
      if (!plate) return
      setErr('')
      setLoading(true)

      try {
        const res = await appUserService.getCrimeRecords({
          filter: {
            customerRecordPlatenumber: plate,
            vehicleType: Number(vehicleType)
          }
        })

        if (!mounted) return
        if (res?.statusCode === 200) {
          const list = res?.data?.data || []
          setViolations(list)
          onCountChange?.(Array.isArray(list) ? list.length : 0)
        } else {
          setErr(`Lỗi: ${res?.statusCode || 'UNKNOWN'}`)
          onCountChange?.(0)
        }
      } catch (e) {
        if (!mounted) return
        setErr(e?.message || 'Không thể lấy dữ liệu vi phạm')
        onCountChange?.(0)
      } finally {
        if (mounted) setLoading(false)
      }
    }

    fetchViolations()
    return () => {
      mounted = false
    }
  }, [plate, vehicleType, onCountChange])

  if (!plate) return null

  return (
    <div className="traffic-fine-violation-list-wrap">
      {loading ? (
        <div className="traffic-fine-violation-loading">
          <span className="traffic-fine-violation-loading-spinner" />
          <span>Đang tải dữ liệu...</span>
        </div>
      ) : err ? (
        <div className="traffic-fine-violation-error">{err}</div>
      ) : violations.length ? (
        <div className="traffic-fine-violation-list">
          {violations.map((v, idx) => (
            <ViolationItem
              key={`${idx}-${v?.customerRecordPlatenumber || 'plate'}`}
              violation={v}
              index={idx}
              carTypeLabel={carTypeLabel}
              defaultOpen={autoOpen ? idx === 0 : false}
            />
          ))}
        </div>
      ) : (
        <div className="traffic-fine-violation-empty">Không tìm thấy dữ liệu vi phạm</div>
      )}
    </div>
  )
}
